
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

@Options({
  data() {
    return {
      isShowPoster: false,
    }
  },
  methods: {
    ...mapMutations(['SET_PAGE', 'SET_STEP', 'SET_ISMAP']),
    handleRestart() {
      this.SET_PAGE(1);
      this.SET_STEP(1);
      this.SET_ISMAP(false);
      window.location.reload();
    },
  }
})
export default class End extends Vue {}
